<h4>{{assessment?.introduction_heading}}</h4>
<p [innerHTML]="assessment?.participant_instruction"></p>
<p [innerHTML]="assessment?.domain_instruction"></p>


<table formArrayName="rating_scale" class="rating-scale-table">
  <tbody>
    <tr class="top-row">
      <td rowspan="3">Scale for Reference</td>
      <td *ngFor="let d of scaleArray.controls; let i = index" [formGroupName]="i">{{d.get('rating_scale_name')?.value}}
      </td>
    </tr>

    <tr>
      <td *ngFor="let d of scaleArray.controls; let i = index" [formGroupName]="i">
        {{d.get('rating_scale_value')?.value}}</td>
    </tr>

    <tr>
      <td *ngFor="let d of scaleArray.controls; let i = index" [formGroupName]="i">
        {{d.get('rating_scale_description')?.value}}</td>
    </tr>

  </tbody>
</table>
